import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { gsap } from 'gsap'

import Draggable from 'gsap/dist/Draggable'
import InertiaPlugin from 'gsap/dist/InertiaPlugin'

const useDraggable = (target, config, deps = []) => {
  const draggable = useRef()

  useIsomorphicLayoutEffect(() => {
    gsap.registerPlugin(Draggable, InertiaPlugin)
  }, [])

  useIsomorphicLayoutEffect(() => {
    if (!draggable.current) {
      draggable.current = Draggable.create(target.current, config)
    }

    return () => {
      if (!draggable.current) return
      draggable.current[0].kill()
      draggable.current = null
    }
  }, deps)

  return draggable
}

export default useDraggable
